'use strict';

module.exports = {
    stickyColumsObserverInit: function () {
        var stickyColumns = document.querySelectorAll('.primary-images,.product-details-column');

        stickyColumns.forEach(function (column) {
            if (column.style.top !== null && column.style.top !== '' && column.style.top !== undefined) {
                column.style.setProperty('top', document.querySelector('.site-header').offsetHeight + 'px');
            }
        });
    }
};
